import { render, staticRenderFns } from "./OpenCourse.vue?vue&type=template&id=3c9aa0e5"
import script from "./OpenCourse.vue?vue&type=script&lang=ts"
export * from "./OpenCourse.vue?vue&type=script&lang=ts"
import style0 from "./OpenCourse.vue?vue&type=style&index=0&id=3c9aa0e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports